import environment from "../../../common/environment";

/*----- HELPERS -----*/
export function getSuggestionsApiCall(searchTerms = '') {
  let url = new URL(`${environment().searchV2Api}/suggestion`);
  url.searchParams.set('searchTerms', searchTerms);
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });
}